'use client';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/Toast';
import { useToast } from '@/hooks/useToast';
import { cn } from '@/lib/utils';
import { FiX } from 'react-icons/fi';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        toastType,
        title,
        description,
        action,
        ...props
      }) {
        return (
          <Toast key={id} {...props}>
            <div className="flex flex-row gap-4 items-center">
              {toastType === 'error' && (
                <div className="w-4 h-4 rounded-full bg-notify flex items-center justify-center">
                  <FiX className="stroke-white stroke-[3px] w-3 h-3" />
                </div>
              )}
              <div className="flex flex-col">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription
                    className={cn('', {
                      'text-base': !title,
                    })}>
                    {description}
                  </ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
